module.exports = __webpack_public_path__ + "img/squarespace.c69b595f.png";